import { object, array, boolean, number, string } from 'yup';
import addIBANValidation from '@afosto/utils-react/validators/validIBAN';

addIBANValidation();

export default object().shape({
  name: string().required(),
  cocNumber: string(),
  isPrimary: boolean(),
  paymentTerm: number(),
  currentDueAmount: number(),
  spendingLimit: number(),
  accountManager: object().nullable(),
  iban: array().validIBAN().nullable(),
  receiveInvoiceInEmail: boolean(),
  receiveInvoiceInMail: boolean(),
  receiveInvoiceAtDelivery: boolean(),
});
